module.exports = __webpack_public_path__ + "static/img/slogan.9a5cfd73.png";